import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { Observable } from 'rxjs';

import { OnboardingData } from '../../models/onboarding-data';
import { OnboardingStoreService } from '../../store/services/onboarding-store.service';
import { RouteService } from '@core-layout/app/services/route.service';
import { NavigationConfigService } from '@onboarding/services/navigation-config.service';
import {Platform} from "@angular/cdk/platform";
import {HybridService} from "../../../core-modules/hybrid/hybrid.service";
import { StatusBarModeDirective } from '../../../core-modules/directives/status-bar-mode/status-bar-mode.directive';
import { RpcButtonComponent } from '../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { DefaultImageComponent } from '../../../media/components/default-image/default-image.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'onboarding-dialog',
    templateUrl: './onboarding-dialog.component.html',
    styleUrls: ['./onboarding-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [StatusBarModeDirective, RpcButtonComponent, DefaultImageComponent, AsyncPipe, TranslateModule]
})
export class OnboardingDialogComponent implements OnDestroy {

    public onboardingDataItem$: Observable<OnboardingData | null> = this.onboardingStoreService.itemToDisplay$;
    public selectedItemIndex$: Observable<number> = this.onboardingStoreService.selectedItemIndex$;
    public itemsImages$: Observable<string[]> = this.onboardingStoreService.itemsImages$;

    constructor(
        private readonly dialogRef: DialogRef<unknown, OnboardingDialogComponent>,
        private readonly onboardingStoreService: OnboardingStoreService,
        private readonly routeService: RouteService,
        private readonly navigationConfigService: NavigationConfigService,
        private readonly platform: Platform,
        private readonly hybridService: HybridService,
    ) { }

    public previous(): void {
        this.onboardingStoreService.setPreviousSelectedIndex();
    }

    public next(): void {
        this.onboardingStoreService.setNextSelectedIndex();
    }

    public redirect(configString: string, isExternal: boolean): void {
        if (isExternal) {
            if (this.platform.IOS && this.hybridService.isHybrid$.value) {
                window.open(configString, '_top');
            } else {
                window.open(configString, '_blank');
            }
        } else {
            const parsed = this.navigationConfigService.parse(configString);

            if (parsed?.route) {
                this.routeService.navigate(parsed.route, parsed.extras).catch(() => { });
            }
        }

        this.close();
    }

    public close(): void {
        this.dialogRef.close();
    }

    public ngOnDestroy(): void {
        this.onboardingStoreService.markAsViewed();
    }
}